import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import { ngxAuthInterceptor, provideDefaultCultures } from '@mds/ngx-auth';
import { acceptLanguageInterceptor, retryInterceptor } from '@mds/ngx-core';
import { provideMdsErrorHandler } from '@mds/ngx-diagnostics';
import { provideNgxFilter, withPersistence } from '@mds/ngx-filter';
import { appRoutes } from './app.routes';
import { provideAppInsight } from './configuration/providers/app-insights.factory';
import { provideConfiguration } from './configuration/providers/configuration.factory';
import { provideDeDateFormat } from './configuration/providers/de-date-format.factory';
import { provideForceLightTheme } from './configuration/providers/force-lightmode.factory';
import { provideMaterial } from './configuration/providers/material.factory';
import { provideMetrics } from './configuration/providers/metric.factory';
import { provideAuth } from './configuration/providers/ngx-auth.factory';
import { provideTitleStrategy } from './configuration/providers/title-strategy.factory';
import { provideTranslations } from './configuration/providers/translate.factory';
import { provideNavigationItems } from './navigation/factories/navigation-items.factory';
import { responseErrorInterceptor } from './shared/interceptors/response-error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withRouterConfig({
        canceledNavigationResolution: 'computed',
      }),
    ),
    provideHttpClient(
      withInterceptors([
        retryInterceptor,
        acceptLanguageInterceptor,
        ngxAuthInterceptor,
        responseErrorInterceptor,
      ]),
    ),
    provideAppInsight(),
    provideMetrics(),
    provideConfiguration(),
    provideMaterial(),
    provideMdsErrorHandler(),
    provideNavigationItems(),
    provideTranslations(),
    provideDefaultCultures(),
    provideNgxFilter(withPersistence()),
    provideTitleStrategy(),
    provideForceLightTheme(),
    provideDeDateFormat(),
    provideAuth(),
  ],
};
